// extracted by mini-css-extract-plugin
module.exports = {"player_section_wrapper":"beat-result_player_section_wrapper__9VJAI","button_wrapper":"beat-result_button_wrapper__3SbV5"};